import { Component } from '@angular/core';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-careers-benefits-section',
  templateUrl: './careers-benefits-section.component.html',
  styleUrls: ['./careers-benefits-section.component.scss'],
  standalone: true,
  imports: [TuiIcon],
})
export class CareersBenefitsSectionComponent {}
